import { render, staticRenderFns } from "./Achievements.vue?vue&type=template&id=c4c5adbc"
import script from "./Achievements.vue?vue&type=script&lang=js"
export * from "./Achievements.vue?vue&type=script&lang=js"
import style0 from "./Achievements.vue?vue&type=style&index=0&id=c4c5adbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports